import React from 'react'

import Loading from '../layout/Loading'
import Grid from '../layout/Grid'
import NoResults from '../layout/NoResults'
import VideoCard from './VideoCard'
import type { Video } from '../../../api/videos/types'
import useScreenSize from '../../../hocs/useScreenSize'

type Props = { data: Video[] | null | undefined, isLoading: boolean, error: Error | null }
const VideoGrid: React.FC<Props> = ({ data, isLoading, error }) => {
  const screenSize = useScreenSize()
  if(isLoading) return <Loading size='fill-container' />
  if(error) return <div>{error.message}</div>
  if(!data || data.length === 0) return <NoResults />
  return (
    <Grid>
      {data
        ?.sort((a) =>  a.userActivity?.watched ? 1 : -1)
        .map((video) => (
          <VideoCard
            id={video.id}
            key={video.title}
            title={video.title}
            image={screenSize.isMd ? video.thumbnailsUrls?.desktop : video.thumbnailsUrls?.mobileVertical}
            previewUrl={video.previewUrl}
            authors={video.authors}
            duration={video.watchTime}
            viewersCount={video.viewersCount}
            type={video.type}
            difficulty={video.difficultyLevel.name}
            category={video.mainCategory.name}
            currentPlayTime={video.userActivity?.currentPlayTime}
            watched={video.userActivity?.watched}
            bookmarked={video.userActivity?.saved}
          />
        )
      )}
    </Grid>
  )
}

export default VideoGrid
